"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackagingSet = void 0;
const class_validator_1 = require("class-validator");
const common_1 = require("../../common");
const models_1 = require("../../partners/models");
const enums_1 = require("../../sales-order/enums");
const models_2 = require("../../setup/models");
const packaging_set_line_model_1 = require("./packaging-set-line.model");
const shipping_kit_model_1 = require("./shipping-kit.model");
class PackagingSet extends common_1.MongoDocument {
}
__decorate([], PackagingSet.prototype, "customer", void 0);
__decorate([], PackagingSet.prototype, "customerRef", void 0);
__decorate([], PackagingSet.prototype, "name", void 0);
__decorate([], PackagingSet.prototype, "setComplete", void 0);
__decorate([
    class_validator_1.IsString(),
    class_validator_1.IsOptional()
], PackagingSet.prototype, "attention", void 0);
__decorate([], PackagingSet.prototype, "shipTo", void 0);
__decorate([], PackagingSet.prototype, "shipToRef", void 0);
__decorate([], PackagingSet.prototype, "shippingNotes", void 0);
__decorate([], PackagingSet.prototype, "shippingMethod", void 0);
__decorate([], PackagingSet.prototype, "dropShip", void 0);
__decorate([], PackagingSet.prototype, "dropShipVerified", void 0);
__decorate([], PackagingSet.prototype, "dropShipVerifiedBy", void 0);
__decorate([], PackagingSet.prototype, "dropShipVerifiedAt", void 0);
__decorate([], PackagingSet.prototype, "numberOfKits", void 0);
__decorate([], PackagingSet.prototype, "base", void 0);
__decorate([], PackagingSet.prototype, "fleet", void 0);
__decorate([], PackagingSet.prototype, "type", void 0);
__decorate([], PackagingSet.prototype, "lines", void 0);
__decorate([], PackagingSet.prototype, "kits", void 0);
__decorate([], PackagingSet.prototype, "shipFromLocation", void 0);
PackagingSet = __decorate([], PackagingSet);
exports.PackagingSet = PackagingSet;
//# sourceMappingURL=packaging-set.model.js.map